// extracted by mini-css-extract-plugin
export default {"label":"u81f5H"};